const EXPIRY_OPTIONS = [
  // { label: '1 hour', value: '1_hour', hours: 1 }, //commented for future reference
  { label: 'One day', value: '1_day', days: 1 },
  { label: 'Two days', value: '2_days', days: 2 },
  { label: 'Three days', value: '3_days', days: 3 },
  { label: 'Four days', value: '4_days', days: 4 },
  { label: 'Five days', value: '5_days', days: 5 },
];

export default EXPIRY_OPTIONS;
